import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const columns: TableColumn[] = [
  { id: 'from', label: 'From (PC)', align: 'left' },
  { id: 'to', label: 'To (OC)', align: 'left' },
  { id: 'vesselPairLimits', label: 'Vessel pair limits', align: 'right' },
  { id: 'action', label: 'Action', align: 'right' },
];
